"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _TreeItemProvider = require("azure-devops-ui/Utilities/TreeItemProvider");
var _ManagementGroupType = require("./ManagementGroupType");
var _ManagementGroup = require("../Models/ManagementGroup");
var _TreeEx = require("azure-devops-ui/TreeEx");
var _List = require("azure-devops-ui/List");
var _react2 = require("@fluentui/react");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var ServiceTreeSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(ServiceTreeSelector, _React$Component);
  var _super = _createSuper(ServiceTreeSelector);
  function ServiceTreeSelector(props) {
    var _this;
    _classCallCheck(this, ServiceTreeSelector);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "generateTreeItems", function (expanded) {
      var isMounted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _this.treeItemProvider.clear();
      if (_this.props.managementGroups.length === 0) {
        return;
      }
      _this.props.managementGroups.filter(function (child) {
        return child.type === _ManagementGroupType.ManagementGroupType.Division;
      }).map(function (child) {
        return _this.treeRecursiveStep(child, expanded);
      }).filter(function (item) {
        var _item$childItems;
        return (_item$childItems = item.childItems) !== null && _item$childItems !== void 0 ? _item$childItems : _this.matchesFilter(item.data);
      })
      // Tree insertion adds in the opposite direction, reverse to maintain alphabetical order
      .reverse().forEach(function (item) {
        _this.treeItemProvider.add(item);
      });

      // Do not do state updates if not mounted (such as if it is called from constructor)
      if (isMounted) {
        if (_this.treeItemProvider.length === 0) {
          _this.setState({
            showNoResultsDropdown: true
          });
        } else {
          _this.setState({
            showNoResultsDropdown: false
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getChildren", function (id, expanded) {
      if (_this.props.managementGroupParentMap[id] === undefined) {
        return [];
      }
      return _this.props.managementGroupParentMap[id].reduce(function (filtered, item) {
        // 1. If current item matches filter, then show the entire tree of
        // current item collapsed.
        // 2. Else if
        //   a. Any of current item's child matches filter, step down
        //      recursively into the children.
        //   b. Or if the request is for a collapsed tree (expanded == false),
        //      we will include all children irrespective of filter match.
        if (_this.matchesFilter(item)) {
          filtered.push(_this.treeRecursiveStep(item, false));
        } else if (_this.getFilteredChildrenCount(item.id) > 0 || !expanded) {
          filtered.push(_this.treeRecursiveStep(item, expanded));
        }
        return filtered;
      }, []);
    });
    _defineProperty(_assertThisInitialized(_this), "getFilteredChildrenCount", function (id) {
      if (_this.filteredParentChild[id] === undefined || _this.props.managementGroupParentMap[id] === undefined) {
        return 0;
      }
      var totalChildren = _this.filteredParentChild[id].length;
      _this.props.managementGroupParentMap[id].forEach(function (child) {
        totalChildren += _this.getFilteredChildrenCount(child.id);
      });
      return totalChildren;
    });
    _defineProperty(_assertThisInitialized(_this), "matchesFilter", function (item) {
      if (!_this.hasFilterApplied) {
        return true;
      }
      var text = _this.props.searchQuery.toLocaleLowerCase();
      return item.name.toLocaleLowerCase().includes(text) || item.id === text;
    });
    _defineProperty(_assertThisInitialized(_this), "onFilter", function () {
      Object.keys(_this.props.managementGroupParentMap).forEach(function (parentId) {
        _this.filteredParentChild[parentId] = _this.props.managementGroupParentMap[parentId].filter(function (item) {
          return _this.matchesFilter(item);
        });
      });
      _this.generateTreeItems(_this.hasFilterApplied);
    });
    _defineProperty(_assertThisInitialized(_this), "onSelection", function (value, action) {
      var _this$treeItemProvide;
      var item = (_this$treeItemProvide = _this.treeItemProvider.value[value[0].beginIndex]) === null || _this$treeItemProvide === void 0 ? void 0 : _this$treeItemProvide.underlyingItem.data;
      if (!item) {
        return;
      }
      var payload = {
        key: item.id,
        name: item.name
      };
      if (action === "select") {
        if (item.type === _ManagementGroupType.ManagementGroupType.Service) {
          _this.props.selectedProductsDispatch({
            type: "add",
            payload: payload
          });
          _this.props.onSelect();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "treeRecursiveStep", function (item, expanded) {
      var _item$type;
      var children = _this.getChildren(item.id, expanded);
      var returnData = {
        data: {
          id: item.id,
          name: item.name,
          type: (_item$type = item.type) !== null && _item$type !== void 0 ? _item$type : _ManagementGroupType.ManagementGroupType.Unknown,
          formattedType: _ManagementGroup.ManagementGroup.formatType(item.type)
        },
        expanded: expanded
      };
      if (children.length > 0) {
        returnData.childItems = children;
      }
      return returnData;
    });
    _this.filteredParentChild = {};
    _this.treeItemProvider = new _TreeItemProvider.TreeItemProvider([]);
    if (props.managementGroups) {
      _this.generateTreeItems(false, false);
    }
    _this.treeSelection = new _List.ListSelection({
      selectOnFocus: false,
      multiSelect: true
    });
    _this.treeSelection.subscribe(_this.onSelection);
    _this.state = {
      showNoResultsDropdown: false
    };
    return _this;
  }
  _createClass(ServiceTreeSelector, [{
    key: "hasFilterApplied",
    get: function get() {
      return this.props.searchQuery.length > 0;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // When new items are loaded in, generate the tree to replace the <Spinner/>
      if (prevProps.managementGroups !== this.props.managementGroups || prevProps.managementGroupParentMap !== this.props.managementGroupParentMap || prevProps.isLoading !== this.props.isLoading) {
        this.generateTreeItems(false);
      }

      // Apply the filter every time searchQuery changes.
      // No debouncing is necessary since due to the <TagPicker/> `resolveDelay` property
      if (prevProps.searchQuery !== this.props.searchQuery) {
        this.onFilter();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var tableColumns = [{
        id: "name",
        name: "Name",
        indentationSize: 8,
        renderCell: _TreeEx.renderExpandableTreeCell,
        width: -100
      }, {
        id: "formattedType",
        name: "Type",
        renderCell: _TreeEx.renderTreeCell,
        width: 125
      }];
      var dropdownContent = /*#__PURE__*/React.createElement(_TreeEx.Tree, {
        columns: tableColumns,
        containerClassName: "custom-scrollbar"
        // @ts-ignore: https://azdevinternal.azureedge.net/components/tree uses ITreeItemProvider but it's broken in the sandbox and here
        ,

        itemProvider: this.treeItemProvider,
        onToggle: function onToggle(e, treeItem) {
          _this2.treeItemProvider.toggle(treeItem.underlyingItem);
        },
        ref: this.props.treeRef,
        scrollable: true,
        selection: this.treeSelection
      });
      if (this.props.isLoading) {
        dropdownContent = /*#__PURE__*/React.createElement("div", {
          className: "spinner-container"
        }, /*#__PURE__*/React.createElement(_react2.Spinner, {
          label: t("repositoryOwnerPanel.assign.service.loadingServices"),
          size: _react2.SpinnerSize.large
        }));
      } else if (this.state.showNoResultsDropdown) {
        dropdownContent = /*#__PURE__*/React.createElement("div", {
          className: "no-results-container",
          role: "row"
        }, /*#__PURE__*/React.createElement("div", {
          role: "gridcell"
        }, /*#__PURE__*/React.createElement(_react2.Text, {
          "aria-label": t("repositoryOwnerPanel.assign.service.noResultsFoundText"),
          role: "alert"
        }, t("repositoryOwnerPanel.assign.service.noResultsFoundText"))));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "flex-row",
        id: "st-container"
      }, dropdownContent);
    }

    /**
     * Generates tree items by starting with Division as the first level and then
     * recursively generates the children.
     */

    /**
     * Recursively generates children for a specified node
     */

    /**
     * Recursively counts how many children (and grandchildren, etc) this node has matching the filter
     */

    /**
     * Performs text match on case insensitive name or exact match GUID
     */

    /**
     * Uses this.matchesFilter to find only the relevant items and saves them to this.filteredParentChild
     * After that is generated, calls this.generateTreeItems to make a new tree based on these items
     * If targetId is passed in through props, the text will initially be set as that ID. Find the matching
     * node and select it.
     */

    /**
     * Subscription listener for the tree selection. When the internal state of the tree picker is changed,
     * the selected value gets bubbled up to the <TagPicker/>. Since deselection is not allowed within
     * this component, and is not visibly rendered, no action is taken on unselect.
     */

    /**
     * Populates data and childItems (if applicable) field for ITreeItem
     */
  }]);
  return ServiceTreeSelector;
}(React.Component);
var _default = ServiceTreeSelector;
exports.default = _default;